import styled from "styled-components";
import { Collapse, Divider, Flex, Modal, Typography } from "antd";
import { DownOutlined } from "@ant-design/icons";

export const StyledBorderedBox = styled(Flex).attrs({
  vertical: true,
})`
  border: 1px solid #e4e4e7;
  border-radius: 10px;
  padding: 12px 20px;
  width: 100%;
`;

export const StyleActiveUserWrapper = styled(StyledBorderedBox)`
  padding: 20px;
  position: relative;
  width: 40%;
  gap: 10px;
`;

export const StyledBorderedRowBox = styled(Flex).attrs({})`
  border: 1px solid #e4e4e7;
  border-radius: 10px;
  padding: 20px;
  width: 100%;
`;

export const StyledBox = styled(StyledBorderedBox).attrs({
  justify: "space-between",
})`
  height: 90px;
`;

export const StyledProgressWrapper = styled(Flex).attrs({
  vertical: true,
})`
  padding: 20px 20px 10px;
  border-radius: 10px;
  transition: all 0.3s ease-in-out;
  box-shadow: 0px 0px 4px 0px #0000001a;
  border: 1px solid #f2f2f2;
`;

export const StyledIncomeHistoryModal = styled(Modal)`
  direction: rtl;
  .ant-modal-footer {
    display: flex;
    justify-content: center;
    margin-top: 40px;
  }
  .ant-btn {
    width: 180px;
    height: 44px;
    margin: 0;
  }
`;

export const StyledLightText = styled(Typography.Text)`
  color: #808080;
  font-size: 12px;
  line-height: 24px;
`;

export const StyledBigText = styled(Typography.Text)`
  color: #313131;
  font-size: 21px;
  font-weight: 700;
`;

export const StyledBigXLText = styled(StyledBigText)`
  font-size: 36px;
`;

interface PercentageTextProps {
  color?: "gray" | "green" | "red";
}

export const StyledPercentageText = styled(
  Typography.Text
)<PercentageTextProps>`
  color: ${(props) =>
    props.color === "gray"
      ? "#808080"
      : props.color === "green"
      ? "#22C55E"
      : "#EF4444"};
  font-size: 13px;
  font-weight: 500;
`;

export const StyledTitleText = styled(Typography.Text)`
  font-size: 18px;
  font-family: "Alef", sans-serif;
`;

interface ShowMoreProps {
  isBig?: boolean;
}

export const StyledShowMore = styled(Flex)<ShowMoreProps>`
  border-radius: 50%;
  box-shadow: 0px 0px 4px 0px #00000040;
  cursor: pointer;
  height: ${(props) => (props.isBig ? "24px" : "18px")};
  width: ${(props) => (props.isBig ? "24px" : "18px")};
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  align-self: end;
`;

export const StyledAbsoluteShowMore = styled(Flex)`
  position: absolute;
  right: 0;
  left: 0;
  margin: auto;
  bottom: -16px;
  justify-content: center;
`;

export const StyledCollape = styled(Collapse).attrs({
  collapsible: "icon",
  bordered: false,
  expandIconPosition: "end",
  ghost: true,
})`
  * {
    padding: 0 !important;
  }
`;

interface DownOutlinedProps {
  isActive: undefined | boolean;
}

export const StyledDownOutlined = styled(DownOutlined)<DownOutlinedProps>`
  color: #5f5df0;
  font-size: 7px;
  transform: ${(props) => (props.isActive ? "rotate(180deg)" : "rotate(0deg)")};
  transition: transform 0.3s ease-in-out;
`;

export const StyledShowMoreScroll = styled(Flex).attrs({
  justify: "center",
})`
  position: absolute;
  bottom: -15px;
  margin: auto;
  left: 0;
  right: 0;
`;

export const StyledActiveUsersWrapper = styled(Flex).attrs({
  vertical: true,
  gap: 20,
})`
  max-height: 495px;
  overflow-y: auto;
  position: relative;
  /* padding-left: 10px; */

  &::-webkit-scrollbar {
    width: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #5f5df0;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
`;

export const StyledNoDataMessage = styled(Flex).attrs({
  vertical: true,
  justify: "center",
})`
  direction: rtl;
  font-size: 16px;
  background-color: white;
  width: 177px;
  height: 90px;
  border-radius: 10px;
  position: relative;
`;

export const StyledDoughnutWrapper = styled(Flex).attrs({
  justify: "center",
  align: "center",
})`
  width: 301px;
  height: 301px;
  min-height: 301px;
  min-width: 301px;
  margin: 20px auto;
  position: relative;
  background: repeating-linear-gradient(
    white,
    white 50px,
    rgb(223 221 221) 51px
  );
`;

export const StyledAbsoluteText = styled(Typography.Text)`
  position: absolute;
  font-size: 12px;
  color: #313131;
  margin: auto;
  offset: 0 0 0 0;
  top: 40%;
`;

export const StyleSixMonthsRevenuesWrapper = styled(Flex).attrs({})`
  gap: 20px;
  row-gap: 0;
  max-width: 100%;
  overflow: auto;
`;

export const StyleMonthRevenuesWrapper = styled(Flex)`
  height: 72px;
  gap: 15px;
  align-items: center;
`;

export const StyleMonthsRevenuesWrapper = styled(Flex).attrs({
  vertical: true,
})`
  justify-content: space-between;
  align-items: end;
  max-width: 70%;
`;

export const StyledMonthIncome = styled(Flex).attrs({
  vertical: true,
})`
  justify-content: space-between;
  height: 80%;
  min-width: max-content;
`;

export const StyledDivider = styled(Divider).attrs({
  type: "vertical",
})`
  height: 45px;
  margin: 0;
`;

export const ReadMoreBtn = styled(Typography.Text)`
  color: #5f5df0;
  cursor: pointer;
  text-decoration: underline;
  font-size: 12px;
  line-height: 24px;
  margin-top: 10px;
  &:hover {
    color: #3b3bff;
  }
`;

export const SubHeader = styled(Typography.Text)`
  text-decoration: underline;
  font-size: 12px;
  line-height: 24px;
  margin-bottom: 10px;
`;
